<div *ngIf="form" [formGroup]="form" class="customer-details-form">
  @if (layout === 'default') {
  <!-- ── Business Information ───────────────────────────────────── -->
  <div class="form-section">
    <div class="form-section__header">
      <span class="form-section__title">Business Information</span>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Customer Name<span class="required-asterisk">*</span></mat-label>
            <input matInput formControlName="companyName" (blur)="onCompanyNameBlur()" />
            <mat-error *ngIf="form.controls.companyName.hasError('required')">
              {{ errorMessages.companyName.required }}
            </mat-error>
            <mat-error *ngIf="form.controls.companyName.hasError('minlength')">
              {{ errorMessages.companyName.minlength }}
            </mat-error>
            <mat-error *ngIf="form.controls.companyName.hasError('maxlength')">
              {{ errorMessages.companyName.maxlength }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-6">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Display Name<span class="required-asterisk">*</span></mat-label>
            <input matInput [formControl]="form.controls.displayName" />
            <mat-error *ngIf="form.controls.displayName.hasError('required')">
              {{ errorMessages.displayName.required }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    @if (!hideAccountNumber) {
    <div class="row">
      <div class="col-6">
        <div class="form-control form-control-no-margin">
          <mat-form-field appearance="outline">
            <mat-label>Account Number<span class="required-asterisk">*</span></mat-label>
            <input matInput [formControl]="form.controls.companyAccountNumber" />
            <mat-error *ngIf="form.controls.companyAccountNumber.hasError('required')">
              {{ errorMessages.companyAccountNumber.required }}
            </mat-error>
            <mat-error *ngIf="form.controls.companyAccountNumber.hasError('pattern')">
              {{ errorMessages.companyAccountNumber.pattern }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    }
    <div class="row">
      <div class="col-6">
        <div class="form-control form-control-no-margin">
          <mat-form-field appearance="outline">
            <mat-label>Salesperson ID</mat-label>
            <input matInput [formControl]="form.controls.salesPersonId" />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Contact Person ─────────────────────────────────────────── -->
  <div class="form-section">
    <div class="form-section__header">
      <span class="form-section__title">Contact Person</span>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>First Name</mat-label>
            <input matInput [formControl]="form.controls.contactFirstName" />
            <mat-error *ngIf="form.controls.contactFirstName.hasError('required')">
              {{ errorMessages.contactFirstName.required }}
            </mat-error>
            <mat-error *ngIf="form.controls.contactFirstName.hasError('minlength')">
              {{ errorMessages.contactFirstName.minlength }}
            </mat-error>
            <mat-error *ngIf="form.controls.contactFirstName.hasError('maxlength')">
              {{ errorMessages.contactFirstName.maxlength }}
            </mat-error>
            <mat-error *ngIf="form.controls.contactFirstName.hasError('pattern')">
              {{ errorMessages.contactFirstName.pattern }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-6">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Last Name</mat-label>
            <input matInput [formControl]="form.controls.contactLastName" />
            <mat-error *ngIf="form.controls.contactLastName.hasError('required')">
              {{ errorMessages.contactLastName.required }}
            </mat-error>
            <mat-error *ngIf="form.controls.contactLastName.hasError('minlength')">
              {{ errorMessages.contactLastName.minlength }}
            </mat-error>
            <mat-error *ngIf="form.controls.contactLastName.hasError('maxlength')">
              {{ errorMessages.contactLastName.maxlength }}
            </mat-error>
            <mat-error *ngIf="form.controls.contactLastName.hasError('pattern')">
              {{ errorMessages.contactLastName.pattern }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-control">
          <div class="email-input-row">
            <mat-form-field appearance="outline" class="email-input-field">
              <mat-label>Email Address</mat-label>
              <input
                matInput
                type="email"
                #emailInput
                placeholder="Enter email address"
                (keyup.enter)="$event.preventDefault(); addEmail(emailInput)"
              />
            </mat-form-field>
            <button
              mat-raised-button
              color="primary"
              type="button"
              class="add-email-btn"
              (click)="addEmail(emailInput)"
            >
              <mat-icon>add</mat-icon>
              Add
            </button>
          </div>
          <div class="email-error" *ngIf="emailError">{{ emailError }}</div>
          <div class="email-chip-list" *ngIf="contactEmails.length > 0">
            <mat-chip-row *ngFor="let email of contactEmails; let i = index" (removed)="removeEmail(i)">
              {{ email }}
              <button matChipRemove type="button" aria-label="Remove email">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-7">
        <div class="form-control-group form-control-group-compact">
          <div class="form-control grow-2">
            <mat-form-field appearance="outline">
              <mat-label>Business Phone</mat-label>
              <input
                matInput
                formControlName="businessPhone"
                mask="(000) 000-0000"
                [showMaskTyped]="true"
                [dropSpecialCharacters]="false"
              />
              <mat-error *ngIf="form.controls.businessPhone.hasError('pattern')">
                {{ errorMessages.businessPhone.pattern }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="form-control grow-0 shrink-2">
            <mat-form-field appearance="outline">
              <mat-label>Ext.</mat-label>
              <input matInput [formControl]="form.controls.businessPhoneExt" />
              <mat-error *ngIf="form.controls.businessPhoneExt.hasError('pattern')">
                {{ errorMessages.businessPhoneExt.pattern }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-5">
        <div class="form-control form-control-no-margin">
          <mat-form-field appearance="outline">
            <mat-label>Mobile Phone</mat-label>
            <input
              matInput
              formControlName="mobilePhoneNumber"
              mask="(000) 000-0000"
              [showMaskTyped]="true"
              [dropSpecialCharacters]="false"
            />
            <mat-error *ngIf="form.controls.mobilePhoneNumber.hasError('pattern')">
              {{ errorMessages.mobilePhoneNumber.pattern }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Address ────────────────────────────────────────────────── -->
  <div class="form-section">
    <div class="form-section__header">
      <span class="form-section__title">Address</span>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Street Address</mat-label>
            <input matInput [formControl]="form.controls.customerAddress" />
            <mat-error *ngIf="form.controls.customerAddress.hasError('maxlength')">
              {{ errorMessages.customerAddress.maxlength }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <div class="form-control form-control-no-margin">
          <mat-form-field appearance="outline">
            <mat-label>City</mat-label>
            <input matInput [formControl]="form.controls.customerCity" />
            <mat-error *ngIf="form.controls.customerCity.hasError('maxlength')">
              {{ errorMessages.customerCity.maxlength }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-4">
        <div class="form-control form-control-no-margin">
          <mat-form-field appearance="outline">
            <mat-label>State</mat-label>
            <mat-select [formControl]="form.controls.customerState">
              <mat-option [value]="''">— None —</mat-option>
              <mat-option *ngFor="let state of usStates" [value]="state.code">
                {{ state.code }} — {{ state.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="col-3">
        <div class="form-control form-control-no-margin">
          <mat-form-field appearance="outline">
            <mat-label>ZIP Code</mat-label>
            <input matInput [formControl]="form.controls.customerZip" />
            <mat-error *ngIf="form.controls.customerZip.hasError('pattern')">
              {{ errorMessages.customerZip.pattern }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <!-- ── Notes ─────────────────────────────────────────────────── -->
  @if (!hideNotes) {
  <div class="form-section">
    <div class="form-section__header">
      <span class="form-section__title">Notes</span>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-control form-control-no-margin">
          <mat-form-field appearance="outline">
            <textarea matInput [formControl]="form.controls.notes" rows="3"></textarea>
            <mat-error *ngIf="form.controls.notes.hasError('maxlength')">
              {{ errorMessages.notes.maxlength }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- ── Payment Method Settings ───────────────────────────────── -->
  <div class="form-section form-section--last">
    <app-customer-settings-form
      [customerSettings]="defaultCustomerSettings"
      [isEditMode]="true"
      [hasDefaultPaymentMethod]="hasDefaultPaymentMethod"
      [enableAutopayFeature]="enableAutopayFeature"
      [enableInvoiceFeature]="enableInvoiceFeature"
      [enableCustomerOverrideFeature]="enableCustomerOverrideFeature"
      [enableAchFeature]="enableAchFeature">
    </app-customer-settings-form>
  </div>
  }

  @if (layout === 'sections') {
  <!-- ══ Business Details ════════════════════════════════════════ -->
  <div class="form-section">
    <div class="form-section__header">
      <span class="form-section__title">Business Details</span>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Customer Name<span class="required-asterisk">*</span></mat-label>
            <input matInput formControlName="companyName" (blur)="onCompanyNameBlur()" />
            <mat-error *ngIf="form.controls.companyName.hasError('required')">{{ errorMessages.companyName.required }}</mat-error>
            <mat-error *ngIf="form.controls.companyName.hasError('minlength')">{{ errorMessages.companyName.minlength }}</mat-error>
            <mat-error *ngIf="form.controls.companyName.hasError('maxlength')">{{ errorMessages.companyName.maxlength }}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-6">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Display Name<span class="required-asterisk">*</span></mat-label>
            <input matInput [formControl]="form.controls.displayName" />
            <mat-error *ngIf="form.controls.displayName.hasError('required')">{{ errorMessages.displayName.required }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-7">
        <div class="form-control-group form-control-group-compact">
          <div class="form-control grow-2">
            <mat-form-field appearance="outline">
              <mat-label>Business Phone</mat-label>
              <input matInput formControlName="businessPhone" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" />
              <mat-error *ngIf="form.controls.businessPhone.hasError('pattern')">{{ errorMessages.businessPhone.pattern }}</mat-error>
            </mat-form-field>
          </div>
          <div class="form-control grow-0 shrink-2">
            <mat-form-field appearance="outline">
              <mat-label>Ext.</mat-label>
              <input matInput [formControl]="form.controls.businessPhoneExt" />
              <mat-error *ngIf="form.controls.businessPhoneExt.hasError('pattern')">{{ errorMessages.businessPhoneExt.pattern }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-5">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Primary Email Address</mat-label>
            <input matInput type="email" formControlName="primaryEmail" (input)="onPrimaryEmailChange()" (blur)="onPrimaryEmailChange()" />
            <mat-error *ngIf="form.controls.primaryEmail.hasError('pattern')">{{ errorMessages.contactEmail.pattern }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Address</mat-label>
            <input matInput [formControl]="form.controls.customerAddress" />
            <mat-error *ngIf="form.controls.customerAddress.hasError('maxlength')">{{ errorMessages.customerAddress.maxlength }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <div class="form-control form-control-no-margin">
          <mat-form-field appearance="outline">
            <mat-label>City</mat-label>
            <input matInput [formControl]="form.controls.customerCity" />
            <mat-error *ngIf="form.controls.customerCity.hasError('maxlength')">{{ errorMessages.customerCity.maxlength }}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-4">
        <div class="form-control form-control-no-margin">
          <mat-form-field appearance="outline">
            <mat-label>State</mat-label>
            <mat-select [formControl]="form.controls.customerState">
              <mat-option [value]="''">— None —</mat-option>
              <mat-option *ngFor="let state of usStates" [value]="state.code">{{ state.code }} — {{ state.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="col-3">
        <div class="form-control form-control-no-margin">
          <mat-form-field appearance="outline">
            <mat-label>ZIP Code</mat-label>
            <input matInput [formControl]="form.controls.customerZip" />
            <mat-error *ngIf="form.controls.customerZip.hasError('pattern')">{{ errorMessages.customerZip.pattern }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <!-- ══ Contact Information ═════════════════════════════════════ -->
  <div class="form-section form-section--last">
    <div class="form-section__header">
      <span class="form-section__title">Contact Information</span>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Contact First Name</mat-label>
            <input matInput [formControl]="form.controls.contactFirstName" />
            <mat-error *ngIf="form.controls.contactFirstName.hasError('minlength')">{{ errorMessages.contactFirstName.minlength }}</mat-error>
            <mat-error *ngIf="form.controls.contactFirstName.hasError('maxlength')">{{ errorMessages.contactFirstName.maxlength }}</mat-error>
            <mat-error *ngIf="form.controls.contactFirstName.hasError('pattern')">{{ errorMessages.contactFirstName.pattern }}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-6">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Contact Last Name</mat-label>
            <input matInput [formControl]="form.controls.contactLastName" />
            <mat-error *ngIf="form.controls.contactLastName.hasError('minlength')">{{ errorMessages.contactLastName.minlength }}</mat-error>
            <mat-error *ngIf="form.controls.contactLastName.hasError('maxlength')">{{ errorMessages.contactLastName.maxlength }}</mat-error>
            <mat-error *ngIf="form.controls.contactLastName.hasError('pattern')">{{ errorMessages.contactLastName.pattern }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Title</mat-label>
            <input matInput [formControl]="form.controls.title" />
          </mat-form-field>
        </div>
      </div>
      <div class="col-6">
        <div class="form-control">
          <mat-form-field appearance="outline">
            <mat-label>Mobile Phone Number</mat-label>
            <input matInput formControlName="mobilePhoneNumber" mask="(000) 000-0000" [showMaskTyped]="true" [dropSpecialCharacters]="false" />
            <mat-error *ngIf="form.controls.mobilePhoneNumber.hasError('pattern')">{{ errorMessages.mobilePhoneNumber.pattern }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-control form-control-no-margin">
          <div class="email-input-row">
            <mat-form-field appearance="outline" class="email-input-field">
              <mat-label>Additional Email Address</mat-label>
              <input matInput type="email" #contactEmailInput placeholder="Enter email address"
                (keyup.enter)="$event.preventDefault(); addEmail(contactEmailInput)" />
            </mat-form-field>
            <button mat-raised-button color="primary" type="button" class="add-email-btn" (click)="addEmail(contactEmailInput)">
              <mat-icon>add</mat-icon>
              Add
            </button>
          </div>
          <div class="email-error" *ngIf="emailError">{{ emailError }}</div>
          <div class="email-chip-list" *ngIf="contactEmails.length > 0">
            <mat-chip-row *ngFor="let email of contactEmails; let i = index" (removed)="removeEmail(i)">
              {{ email }}
              <button matChipRemove type="button" aria-label="Remove email">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
